<template>
    <div class="white-bg">
        <top-carousel></top-carousel>
        <div class="abttyou container">
            <div class="weizhi">
                <h2>
                    <i class="product-title">
                        产品中心&nbsp;&nbsp;&nbsp;&nbsp;PRODUCT CENTER</i
                    >
                    <span
                        ><a @click="jumpPage('/product')">产品中心</a> &gt;
                        {{ detail.title }}</span
                    >
                </h2>
            </div>
            <div class="abounei">
                <h1>{{ detail.title }}</h1>
                <div v-for="item in detail.content" :key="item.label">
                    <h2 v-if="item.label">{{ item.label }}</h2>
                    <div
                        v-for="subitem in item.sublist"
                        :key="subitem.subTitle"
                        :class="subitem.className"
                    >
                        <div>
                            <h3 v-if="subitem.subTitle">
                                {{ subitem.subTitle }}
                            </h3>
                            <p
                                v-for="threeItem in subitem.desc"
                                :key="threeItem"
                            >
                                {{ threeItem }}
                            </p>
                        </div>
                        <div v-if="subitem.url">
                            <img :src="subitem.url" width="100%" />
                        </div>
                    </div>
                </div>
                <div class="clearfix">
                    <div class="prev">
                        上一个：
                        <a
                            @click="changeIndex(detail.F_LastId)"
                            v-if="detail.F_LastTitle"
                            >{{ detail.F_LastTitle }}</a
                        >
                        <span v-else>无</span>
                    </div>
                    <div class="next">
                        下一个：
                        <a
                            @click="changeIndex(detail.F_NextId)"
                            v-if="detail.F_NextTitle"
                            >{{ detail.F_NextTitle }}</a
                        >
                        <span v-else>无</span>
                    </div>
                </div>
            </div>
        </div>
        <div style="height: 40px"></div>
    </div>
</template>

<script>
import TopCarousel from '../../commonComponents/topCarousel'
export default {
    components: { TopCarousel },
    data() {
        return {
            list: [
                {
                    title: '高效机房系统',
                    content: [
                        {
                            sublist: [
                                {
                                    url: require('../../../../assets/img/productDetail/gx4.png'),
                                    desc: [
                                        '高效机房建设是一个完整的链条，包含这五个系统的统一：即空调设备选型、优化设计、稳定的系统控制、安装施工以及智慧化的调试和运维。一个高效机房效果必须涵盖这五点，而同时考验承包商是否拥有能力将五者完美统合。',
                                        '根据相关标准，制冷机房综合能效＞5.0（＜0.70kw/RT ）即为高效机房。',
                                    ],
                                },
                            ],
                        },

                        {
                            label: '1. 总体方案',
                            sublist: [
                                {
                                    subTitle: '',
                                    url: require('../../../../assets/img/productDetail/gx2.png'),
                                },
                            ],
                        },
                        {
                            label: '2. 产品优势',
                            sublist: [
                                {
                                    url: require('../../../../assets/img/productDetail/gx3.png'),
                                    desc: [
                                        '通过高效冷机、高效冷却塔、输送设备优化选型、管路全局低阻优化、低阻力阀门、定制化高效群控系统、BIM设计施工、承诺能效技术服务等方式，实现全年节能30%以上。',
                                    ],
                                },
                            ],
                        },
                        {
                            label: '3. 建筑全年8760h负荷模拟',
                            sublist: [
                                {
                                    url: require('../../../../assets/img/productDetail/gx6.png'),
                                    desc: [
                                        '利用能源模拟软件,通过建模获取建筑全年8760h负荷，为系统的主要设备匹配提供依据。',
                                    ],
                                },
                            ],
                        },
                        {
                            label: '4. 节能优化设计',
                            sublist: [
                                {
                                    url: require('../../../../assets/img/productDetail/gx10.png'),
                                },
                            ],
                        },
                        {
                            label: '5. 装配式高效机房',
                            sublist: [
                                {
                                    subTitle: '5.1 高效机房特点',
                                    url: require('../../../../assets/img/productDetail/gx8.png'),
                                },
                                {
                                    subTitle: '5.2 装配式高效机房实施流程',
                                    url: require('../../../../assets/img/productDetail/gx7.png'),
                                },
                                {
                                    subTitle: '5.3 高效机房与普通机房经济比较',
                                    url: require('../../../../assets/img/productDetail/gx5.png'),
                                },
                            ],
                        },
                        {
                            label: '6. 系统架构',
                            sublist: [
                                {
                                    url: require('../../../../assets/img/productDetail/gx1.png'),
                                },
                            ],
                        },
                    ],
                    id: 'gxjf',
                },
                {
                    title: '自动化系统',
                    content: [
                        {
                            label: '高标准建筑内环境参数自动化控制',
                            sublist: [
                                {
                                    url: require('../../../../assets/img/productDetail/a1.png'),
                                    desc: [
                                        '相对于一般建筑环境的舒适性要求，研究及生产型建筑如生物安全实验室、生物安全三级防护车间、电子半导体生产洁净厂房对于建筑内环境参数有更为严格的要求。',
                                        '生物安全实验室、生物安全三级防护车间对压力梯度有严格的要求，要求绝对负压，保持相对压差梯度。',
                                        '半导体和精密电子制造厂对生产过程环境的常规要求为；温度要求22±2℃；湿度要求：55±5%； FAB区内换气次数25次，生产区域为正压洁净室。',
                                        '制药企业对生产区一般要求为；温度要求22±2℃；湿度要求：55±5%；其中有毒区域为负压洁净室，无毒区域为正压洁净室。',
                                        '自动化系统通过对建筑内集中空调系统的智能化控制，实现建筑内温度、湿度、绝对压力、压差梯度、洁净度等环境参数满足规范、生产工艺、舒适性要求。',
                                        '以ABSL-3级动物实验室为例，自动控制内容：',
                                    ],
                                },
                            ],
                        },
                        {
                            label: '系统开关机及主备设备故障切换控制',
                            sublist: [
                                {
                                    url: require('../../../../assets/img/productDetail/a2.png'),
                                    desc: [
                                        '生物安全实验室要求自控系统在开机、关机、主备风机故障切换时均不得出现正压逆转，核心房间需保持与相邻房间的压差不逆转。这对自动控制系统提出了更高的要求。',
                                    ],
                                },
                            ],
                        },
                        {
                            label: '工艺参数及工艺流程的自动化控制',
                            sublist: [
                                {
                                    subTitle: '废水灭菌过程控制',
                                    url: require('../../../../assets/img/productDetail/a3.png'),
                                },
                                {
                                    subTitle: '生产线控制',
                                    url: require('../../../../assets/img/productDetail/a4.jpg'),
                                    desc: [
                                        '通过对生产车间工艺系统的自动化控制，准确测量和控制生产过程参数，实现生产自动化、并提升至信息化；从而提高生产管理水平及生产效率，节省人力成本，节省能源，提高产品质量，展现企业的现代化。',
                                    ],
                                },
                            ],
                        },
                    ],
                    id: 'zdhxt',
                },
                {
                    title: '数字化系统',
                    content: [
                        {
                            label: '智能可视化数字工厂管理平台',
                            sublist: [
                                {
                                    url: require('../../../../assets/img/productDetail/d1.gif'),
                                    desc: [
                                        '数字化系统利用移动计算机网络技术、自动控制技术、BIM、智能传感技术等，从自动化底层的生产管控、质量控制、设备控制、能耗和物料监测到顶层的设备级、系统级和产业级制造、产品全生命周期、设备全生命周期仿真及分析，实现生产的自动化、数字化和智能化，降低生产的不确定性因素，推动企业提质增效降本。',
                                    ],
                                },
                            ],
                        },
                        {
                            sublist: [
                                {
                                    url: require('../../../../assets/img/productDetail/d2.png'),
                                },
                            ],
                        },
                        {
                            label: '智慧运维综合管理平台',
                            sublist: [
                                {
                                    subTitle: '产品介绍',
                                    url: require('../../../../assets/img/productDetail/d3.png'),
                                    desc: [
                                        '该系统是对设备全生命周期进行管理，通过对设备信息、报修信息、维修信息、维保信息、安防、人员等的全面化管理，进而保证现场生产设备始终保持良好的工作状态和生产质量。',
                                    ],
                                    className: 'mix clearfix',
                                },
                            ],
                        },
                        {
                            sublist: [
                                {
                                    url: require('../../../../assets/img/productDetail/d4.png'),
                                },
                            ],
                        },
                        {
                            label: '智慧运维APP',
                            sublist: [
                                {
                                    subTitle: '产品介绍',
                                    url: require('../../../../assets/img/productDetail/d5.png'),
                                    desc: [
                                        '智慧运维App是一款面向运维人员的专用软件，可以帮助工人快速接收订单,操作方法简单,可以随时管理订单和工单。软件提供包括设备管理、二维码扫描、报修、维修、维保、视频监控、知识库等功能服务。',
                                    ],
                                    className: 'mix-right clearfix',
                                },
                            ],
                        },
                        {
                            sublist: [
                                {
                                    url: require('../../../../assets/img/productDetail/d6.png'),
                                },
                            ],
                        },
                    ],
                    id: 'szhxt',
                },
                {
                    title: '能源管理系统',
                    content: [
                        {
                            sublist: [
                                {
                                    desc: [
                                        '能源管理平台建立在底层设备控制和能量计量的基础上，为建筑能源管理和节能策略提供平台。',
                                        '主要功能如下：',
                                        '1. 了解能耗去向，评估节能潜力，检验节能效果',
                                        '2. 节能任务分解到专业责任人',
                                        '3. 为节能设计提供评估手段、积累参数',
                                        '4. 为节能运行提供检验手段和必要信息',
                                    ],
                                },
                            ],
                        },
                        {
                            label: '产品架构',
                            sublist: [
                                {
                                    url: require('../../../../assets/img/productDetail/e1.png'),
                                },
                            ],
                        },
                        {
                            label: '产品部署',
                            sublist: [
                                {
                                    subTitle: '',
                                    url: require('../../../../assets/img/productDetail/e2.png'),
                                    desc: [
                                        '能源管理系统部署在完善的自动化系统基础上。将建筑内或建筑群内分散的子系统、耗能设备的多种控制信号和参数，接入统一的能效管理平台数据库。产品支持通过以太网、RS485、无线、SNMP、OPC 、Modbus 、DLT645 、ODBC等标准链路和协议通讯。',
                                    ],
                                },
                            ],
                        },
                        {
                            label: '产品功能',
                            sublist: [
                                {
                                    url: require('../../../../assets/img/productDetail/e3.png'),
                                },
                            ],
                        },
                        {
                            sublist: [
                                {
                                    url: require('../../../../assets/img/productDetail/e4.png'),
                                },
                            ],
                        },
                    ],
                    id: 'nyglxt',
                },
            ],
            detail: {},
            id: this.$route.params.id,
        }
    },
    methods: {
        jumpPage(url) {
            this.$router.push(url)
        },
        getDetailInfo() {
            if (this.id) {
                for (let index = 0; index < this.list.length; index++) {
                    let item = this.list[index]
                    if (item.id == this.id) {
                        this.detail = item
                        let nextIndex = index + 1
                        if (nextIndex < this.list.length) {
                            let nextObj = this.list[nextIndex]
                            this.detail.F_NextTitle = nextObj.title
                            this.detail.F_NextId = nextObj.id
                        } else {
                            this.detail.F_NextTitle = null
                            this.detail.F_NextId = null
                        }
                        let lastIndex = index - 1
                        if (lastIndex > -1) {
                            let lastObj = this.list[lastIndex]
                            this.detail.F_LastTitle = lastObj.title
                            this.detail.F_LastId = lastObj.id
                        } else {
                            this.detail.F_LastTitle = null
                            this.detail.F_LastId = null
                        }
                        break
                    }
                }
            }
        },
        changeIndex(id) {
            this.$router.push('/productDetail/' + id)
        },
    },
    mounted() {
        this.getDetailInfo()
    },
}
</script>
